import chineseNewYear from './data/chinese-new-year.json'
import dinosaurLand from './data/dinosaur-land.json'
import dragonRescue from './data/dragon-rescue.json'
import easterEggHunt from './data/easter-egg-hunt.json'
import enchantedForest from './data/enchanted-forest.json'
import fifthBirthdayEaster from './data/fifth-birthday-easter.json'
import mermaidAdventure from './data/mermaid-adventure.json'
import mothersDayLetter from './data/mothers-day-letter.json'
import pirateTreasure from './data/pirate-treasure.json'
import punchTheMonkey from './data/punch-the-monkey.json'
import spaceExplorer from './data/space-explorer.json'
import underwaterKingdom from './data/underwater-kingdom.json'
import type { FeaturedReview, StorefrontData } from './types'

interface StoryDataFile {
  reviews?: {
    featured_reviews: FeaturedReview[]
    review_photos?: string[]
  }
  highlights?: StorefrontData['highlights']
  faq?: StorefrontData['faq']
  social_proof?: StorefrontData['social_proof']
  live_activity?: StorefrontData['live_activity']
}

function computeReviewStats(reviews: FeaturedReview[]) {
  const distribution: Record<string, number> = { '5': 0, '4': 0, '3': 0, '2': 0, '1': 0 }
  let sum = 0

  for (const r of reviews) {
    distribution[String(r.rating)] = (distribution[String(r.rating)] || 0) + 1
    sum += r.rating
  }

  return {
    total_reviews: reviews.length,
    rating_distribution: distribution,
    average_rating: Math.round((sum / reviews.length) * 10) / 10,
  }
}

function buildEntry(data: StoryDataFile): StorefrontData {
  const entry: StorefrontData = {
    highlights: data.highlights,
    faq: data.faq,
    social_proof: data.social_proof,
    live_activity: data.live_activity,
  }

  if (data.reviews?.featured_reviews?.length) {
    entry.reviews = {
      ...computeReviewStats(data.reviews.featured_reviews),
      featured_reviews: data.reviews.featured_reviews,
      review_photos: data.reviews.review_photos,
    }
  }

  return entry
}

export const STOREFRONT_DATA_MAP: Record<string, StorefrontData> = {
  'chinese-new-year': buildEntry(chineseNewYear as StoryDataFile),
  'dinosaur-land': buildEntry(dinosaurLand as StoryDataFile),
  'dragon-rescue': buildEntry(dragonRescue as StoryDataFile),
  'easter-egg-hunt': buildEntry(easterEggHunt as StoryDataFile),
  'enchanted-forest': buildEntry(enchantedForest as StoryDataFile),
  'fifth-birthday-easter': buildEntry(fifthBirthdayEaster as StoryDataFile),
  'mermaid-adventure': buildEntry(mermaidAdventure as StoryDataFile),
  'mothers-day-letter': buildEntry(mothersDayLetter as StoryDataFile),
  'pirate-treasure': buildEntry(pirateTreasure as StoryDataFile),
  'punch-the-monkey': buildEntry(punchTheMonkey as StoryDataFile),
  'space-explorer': buildEntry(spaceExplorer as StoryDataFile),
  'underwater-kingdom': buildEntry(underwaterKingdom as StoryDataFile),
}
